import { Link, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, TrendingUp, Wallet, Menu } from 'lucide-react';
import { cn } from '@/lib/utils';

const navItems = [
  { href: '/dashboard', icon: Home, label: 'Home' },
  { href: '/buy', icon: ShoppingBag, label: 'Shop' },
  { href: '/markets', icon: TrendingUp, label: 'Invest' },
  { href: '/wallet', icon: Wallet, label: 'Wallet' },
  { href: '/profile', icon: Menu, label: 'Menu' },
];

export const BottomNav = () => {
  const location = useLocation();

  return (
    <nav className="bottom-nav glass border-t border-border/50 lg:hidden" data-testid="bottom-nav">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.href || 
            (item.href !== '/dashboard' && location.pathname.startsWith(item.href));
          
          return (
            <Link
              key={item.href}
              to={item.href}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={cn(
                "flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-xl transition-colors",
                isActive 
                  ? "text-cyan-600" 
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <item.icon className={cn("h-5 w-5", isActive && "stroke-[2.5]")} />
              <span className="text-[10px] font-medium">{item.label}</span>
              {isActive && (
                <div className="absolute bottom-1 w-1 h-1 rounded-full bg-cyan-500" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
